import React from "react";
import ExcelDownloader from "../../common/ExcelDownloader/ExcelDownloader";
import { getSimpleFormattedDate } from "../../../utils/utils";

const combineChildrenHeaders = (children) => {
  return children.map((child) => {
    const { id, label, type } = child;
    return { key: id, label: label, type: type || "string" };
  });
};

const generateHeaders = (columns) => {
  return columns.flatMap((column) => {
    if (column?.children) {
      return combineChildrenHeaders(column.children);
    } else {
      const { id, label, type } = column;
      return { key: id, label: label, type: type || "string" };
    }
  });
};

const EVESensitivityExport = ({
  columns,
  datasForTotal,
  datasForReport,
  disabled = true,
} = {}) => {
  const headers = generateHeaders(columns);

  const totalTableData = datasForTotal.map((data) => {
    const row = {};
    headers.forEach((header) => {
      const { key } = header;
      row[key] = data[key];
    });
    return row;
  });

  const flattenDataWithIndentation = (dataArray = [], headers, depth = 0) => {
    let flatList = [];

    dataArray.forEach((data) => {
      const row = {};

      // 1. Process headers for the current object
      headers.forEach((header) => {
        const { key } = header;
        row[key] = data[key];
      });

      // 2. Add indentation to the 'account' key based on current depth
      // 0 = no space, 1 = (4 space), 2 = (8 space), etc.
      const spaceKey = "reportingAccountName";
      if (row.hasOwnProperty(spaceKey)) {
        row[spaceKey] = "    ".repeat(depth) + row[spaceKey];
      }

      flatList.push(row);

      // 3. Recursively handle children
      if (data.children && data.children.length > 0) {
        const children = flattenDataWithIndentation(
          data.children,
          headers,
          depth + 1,
        );
        flatList = [...flatList, ...children];
      }
    });

    return flatList;
  };

  const reportData = flattenDataWithIndentation(datasForReport, headers);

  return (
    <ExcelDownloader
      sheets={[
        {
          name: "EVE_Sensitivity_Total",
          header: headers,
          data: totalTableData,
          showHeader: true,
        },
        {
          name: "EVE_Sensitivity_Report",
          header: headers,
          data: reportData,
          showHeader: true,
        },
      ]}
      disabled={disabled}
      fileName={`EVESensitivity_${getSimpleFormattedDate()}.xlsx`}
    />
  );
};

export default EVESensitivityExport;
